import React, { useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Fetcher } from "../../components/Fetcher";
import { getFeatureToggles } from "../../services/api/featureToggles.api";
import { FeatureTogglesList } from "../../components/FeatureToggles/FeatureTogglesList";
import { PowFeature } from "../../components/PowFeature";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { POW_FEATURES } from "../../services/powFeatures.service";

interface FeatureTogglesListPageProps {
	productId: string;
}

const useStyles = makeStyles((theme) => ({
	title: {
		marginBottom: theme.spacing(4),
	},
	titleWrapper: {
		maxWidth: theme.breakpoints.values.md,
		display: "flex",
		justifyContent: "space-between",
	},
}));

/**
 * Fetch and display feature toggles
 * @param props
 */
export const FeatureTogglesListPage = (props: FeatureTogglesListPageProps) => {
	const classes = useStyles();
	const history = useHistory();

	return (
		<div data-testid={"feature-toggles-list-page"}>
			<div className={classes.titleWrapper}>
				<Typography className={classes.title} variant="h4">
					Feature Toggles
				</Typography>
				<div>
					<PowFeature feature={POW_FEATURES.paFeatures_Admin}>
						<div data-testid="feature-toggle-add-button">
							<Button
								size="small"
								variant="outlined"
								color="primary"
								onClick={() => history.push(`/Products/${props.productId}/FeatureToggles/new`)}
							>
								Add new feature toggle
							</Button>
						</div>
					</PowFeature>
				</div>
			</div>
			{useMemo(() => {
				return (
					<Fetcher action={getFeatureToggles(props.productId)}>
						{({ data }) => <FeatureTogglesList productId={props.productId} featureToggles={data} />}
					</Fetcher>
				);
			}, [props.productId])}
		</div>
	);
};
